import React, { useContext, useEffect, useState } from 'react'
import VBG from '../../../assets/images/VBG.png';
import VBGM from '../../../assets/images/VBGM.png';
import UserContext from 'Contexts/User';
import { useNavigate } from 'react-router-dom';
import { H2 } from './VotingPayment';
import SmallBackArrow from '../../../Components/icons/SmallBackArrow';
import { ButttonDiv } from '../VotingBooster';
import {SendTransactionRequest, useTonConnectUI, useTonWallet} from "@tonconnect/ui-react";
import { auth, db, firestore } from "../../../firebase";
import axios from 'axios';
import AppContext from 'Contexts/AppContext';
import { ToastType } from 'Contexts/Notification';
import { showToast } from 'App';
// import {beginCell, Cell} from 'ton'
import {Cell} from 'ton'
import copy from 'copy-to-clipboard';

// TypeScript declarations for TronLink and TronWeb
declare global {
  interface Window {
    tronWeb?: any;
    tronLink?: any;
  }
}

type TRONWalletPropes = {
  payamount:any
  VTEAmount:any
  payType:any
  miniDays:any
  extraVote:any
  votePackageId:any
  setIsLoading:any
  setPaymentStatus:any
  setShowText:any
  setPayButton:any 
  coinInfo:any
  productId:any
  quantity:any
  setAfterPaymentData:any
  startAgainAction:any
};

interface WalletAddress {
  address: string;
  type: string;
  isDefault: boolean;
  accountInfo?: any;
}

function TRONWallet({
  payamount,
  VTEAmount,
  payType,
  miniDays,
  extraVote,
  votePackageId,
  setIsLoading,
  setPaymentStatus,
  setShowText,
  setPayButton, 
  coinInfo ,
  productId,
  quantity,
  setAfterPaymentData,
  startAgainAction
}:TRONWalletPropes) {
  const { user, userInfo } = useContext(UserContext); 
//  const wallet = useTonWallet();  
 const [tonConnectUi] = useTonConnectUI();  
 const [trxAmount, setTrxAmount] = useState(0);
//  const {getSpinData } = useContext(AppContext);

 const [tronWeb, setTronWeb] = useState<any>(null);
 const [account, setAccount] = useState<string | null>(null);
 const [balance, setBalance] = useState(0);
 const [isConnected, setIsConnected] = useState(false);
 const [recipientAddress, setRecipientAddress] = useState(process.env.REACT_APP_TRON_ACCOUNT_KEY || 'TEEEo69tr9BbHCSXy2LbpM2bWAkXpNvBK5');
//  const [amount, setAmount] = useState(1);
 const [network, setNetwork] = useState('');
 const [availableAddresses, setAvailableAddresses] = useState<WalletAddress[]>([]);
 const [selectedAddress, setSelectedAddress] = useState<string | null>(null);


 const fetchTonPrice = async () => {
  try {
    const response = await axios.get(
      'https://api.coingecko.com/api/v3/simple/price?ids=tron&vs_currencies=usd'
    );
    const price = response.data.tron.usd;    
    setTrxAmount(price);
    return price
  } catch (error) {
    console.error('Error fetching TON price:', error);
  }  
};


// Fetch TON price when the component is mounted

useEffect(() => {
  fetchTonPrice();
  // initTronWeb()
  // @ts-ignore
}, []);



 const payNow = (detail?: any) => {

  const headers = {
    // 'Content-Type': 'application/json',
    "accept": "application/json",
    // @ts-ignore
    "Authorization": `Bearer ${auth?.currentUser?.accessToken}`,
    "content-type": "application/json"
  }  
  const data = {
    userId: `${user?.uid}`,
    userEmail: `${user?.email}`,
    walletType: `wallet connect`,
    amount: Number(payamount && Number(payamount)) / (trxAmount || 5),
    dollarAmount: Number(payamount),
    VTEAmount: Number(VTEAmount),        
    network: `728126428`,    
    origincurrency: `TRX`,
    token: `TRX`,
    event: 'Approved',
    transactionType: payType,
    numberOfVotes: extraVote,
    paymentDetails: detail,
    votePackageId:votePackageId,
    miningPassDurationInDays:miniDays,
    productId:productId,
    quantity:quantity
  }
  console.log("afterPayment Data : ", data)
  axios.post(`${process.env.REACT_APP_V2E}updateUserAfterPayment`,{data},
    {
      headers: headers
    }).then(async (response) => {
      // setApiCalling(false)
      // console.log(,"response.data.data")
      console.log(response.data, "response.data")
      // transactionId.current = response.data
      setAfterPaymentData(response.data)
      setIsLoading(false)
      setPaymentStatus({ type: "success", message: "" })
      setShowText(false)
      setPayButton(false);
      // getSpinData(userInfo?.uid)
      // setShowForWait(true)
    })
    .catch((error) => {
      // setPaymentStatus({ type: 'error', message: '' });
      console.log(error, "response.data")
      setIsLoading(false)
      setPaymentStatus({ type: "error", message: "We apologize for the inconvenience. Please ensure that you have a stable internet connection and try again." })
      setShowText(false)
      setPayButton(false);
    })
}

// Function to validate TRON address format
const isValidTronAddress = (address: string): boolean => {
  // TRON addresses should start with 'T' and be 34 characters long
  return Boolean(address && typeof address === 'string' && address.startsWith('T') && address.length === 34);
};

// Function to get current wallet address using TronLink API
const getCurrentWalletAddress = async (): Promise<string | null> => {
  try {
    if (window.tronLink && typeof window.tronLink.request === "function") {
      const result = await window.tronLink.request({ method: 'tron_requestAccounts' });
      console.log('TronLink requestAccounts result:', result);
      
      if (result && result.code === 200 && window.tronWeb && window.tronWeb.defaultAddress?.base58) {
        return window.tronWeb.defaultAddress.base58;
      }
    }
    
    // Fallback: try to get from tronWeb directly
    if (window.tronWeb && window.tronWeb.defaultAddress?.base58) {
      return window.tronWeb.defaultAddress.base58;
    }
    
    return null;
  } catch (error) {
    console.error('Error getting current wallet address:', error);
    return null;
  }
};

// Function to get all available addresses and their balances
const getAllAddressesAndBalances = async (): Promise<WalletAddress[]> => {
  if (!window?.tronWeb) {
    console.log('TronWeb not available');
    return [];
  }

  const addresses: WalletAddress[] = [];
  
  try {
    console.log('TronWeb object:', window.tronWeb);
    console.log('TronWeb ready:', window.tronWeb.ready);
    
    // First, try to get the current wallet address
    const currentAddress = await getCurrentWalletAddress();
    if (currentAddress && isValidTronAddress(currentAddress)) {
      addresses.push({
        address: currentAddress,
        type: 'HD Wallet (Active)',
        isDefault: true
      });
    }
    
    // Get default address (HD wallet) - try multiple possible properties
    let defaultAddress = window.tronWeb.defaultAddress?.base58;
    if (!defaultAddress && window.tronWeb.defaultAddress?.hex) {
      defaultAddress = window.tronWeb.address.fromHex(window.tronWeb.defaultAddress.hex);
    }
    if (!defaultAddress && window.tronWeb.address) {
      defaultAddress = window.tronWeb.address;
    }
    
    console.log('Default address found:', defaultAddress);
    
    if (defaultAddress && isValidTronAddress(defaultAddress) && !addresses.find(addr => addr.address === defaultAddress)) {
      addresses.push({
        address: defaultAddress,
        type: 'HD Wallet',
        isDefault: true
      });
    }

    // Try to get current selected address
    if (window.tronWeb.ready) {
      try {
        const currentAddress = window.tronWeb.defaultAddress?.base58 || window.tronWeb.address;
        if (currentAddress && isValidTronAddress(currentAddress) && !addresses.find(addr => addr.address === currentAddress)) {
          addresses.push({
            address: currentAddress,
            type: 'Current Wallet',
            isDefault: true
          });
        }
      } catch (error) {
        console.log('Could not get current address:', error);
      }
    }

    // If no addresses found, try alternative methods
    if (addresses.length === 0) {
      console.log('No addresses found with standard methods, trying alternatives...');
      
      // Try to get address from tronLink object
      if (window.tronLink && window.tronLink.defaultAddress?.base58) {
        const tronLinkAddress = window.tronLink.defaultAddress.base58;
        if (isValidTronAddress(tronLinkAddress)) {
          addresses.push({
            address: tronLinkAddress,
            type: 'TronLink Default',
            isDefault: true
          });
        }
      }
      
      // Try to get address from any available property
      const tronWebKeys = Object.keys(window.tronWeb);
      console.log('Available TronWeb properties:', tronWebKeys);
      
      for (const key of tronWebKeys) {
        const value = window.tronWeb[key];
        if (value && typeof value === 'object' && value.base58 && isValidTronAddress(value.base58)) {
          console.log(`Found address in property ${key}:`, value.base58);
          addresses.push({
            address: value.base58,
            type: `Property: ${key}`,
            isDefault: false
          });
        }
      }
    }

    console.log('Final addresses found:', addresses);
    return addresses;
  } catch (error) {
    console.error('Error getting addresses:', error);
    return addresses;
  }
};

// Function to check balance for a specific address
const checkAddressBalance = async (address: string, coinType: string): Promise<number> => {
  if (!window?.tronWeb) return 0;

  try {
    console.log(`Checking balance for address: ${address}, coinType: ${coinType}`);
    
    // Validate address format first
    if (!isValidTronAddress(address)) {
      console.error(`Invalid address format: ${address}`);
      return 0;
    }

    if (coinType === "USDT") {
      // Only check USDT balance if we have a valid contract address
      if (!coinInfo?.ContractAddress) {
        console.log('No USDT contract address available, skipping USDT balance check');
        return 0;
      }
      
      try {
        const contractValue = await window.tronWeb.contract().at(coinInfo.ContractAddress);
        const usdtBalanceUnits = await contractValue.balanceOf(address).call();
        const balance = usdtBalanceUnits / 1e6;
        console.log(`USDT balance for ${address}: ${balance}`);
        return balance;
      } catch (contractError) {
        console.log(`Failed to get USDT balance for ${address}:`, contractError);
        return 0;
      }
    } else {
      // Try to get balance using different methods
      try {
        const trxBalanceSun = await window.tronWeb.trx.getBalance(address);
        const balance = window.tronWeb.fromSun(trxBalanceSun);
        console.log(`TRX balance for ${address}: ${balance}`);
        return balance;
      } catch (balanceError) {
        console.log(`Failed to get balance with trx.getBalance, trying alternative method:`, balanceError);
        
        // Try alternative method using fullNode
        try {
          if (window.tronWeb.fullNode && window.tronWeb.fullNode.getAccount) {
            const accountInfo = await window.tronWeb.fullNode.getAccount(address);
            if (accountInfo && accountInfo.balance) {
              const balance = window.tronWeb.fromSun(accountInfo.balance);
              console.log(`TRX balance for ${address} (via fullNode): ${balance}`);
              return balance;
            }
          }
        } catch (fullNodeError) {
          console.log(`Failed to get balance with fullNode:`, fullNodeError);
        }
        
        return 0;
      }
    }
  } catch (error) {
    console.error(`Error checking balance for ${address}:`, error);
    return 0;
  }
};

// Function to check if HD wallet is active and has sufficient balance
const checkHDWalletStatus = async (requiredAmount: number, coinType: string) => {
  console.log(`Checking HD wallet status. Required: ${requiredAmount} ${coinType}`);
  
  const addresses = await getAllAddressesAndBalances();
  console.log(`Found ${addresses.length} HD wallet addresses to check`);
  
  // Only check HD wallet addresses (skip Gas-Free and other types)
  const hdAddresses = addresses.filter(addr => 
    addr.type.includes('HD') || 
    addr.type.includes('Default') || 
    addr.type.includes('Current') ||
    addr.type.includes('Active')
  );
  
  console.log(`HD wallet addresses found:`, hdAddresses);
  
  for (const addr of hdAddresses) {
    const balance = await checkAddressBalance(addr.address, coinType);
    console.log(`HD Wallet ${addr.address} (${addr.type}) balance: ${balance} ${coinType}`);
    
    if (balance >= requiredAmount) {
      console.log(`HD wallet has sufficient balance: ${balance} >= ${requiredAmount}`);
      return {
        address: addr.address,
        balance: balance,
        type: addr.type,
        isActive: true
      };
    }
  }
  
  console.log('HD wallet does not have sufficient balance');
  return null;
};

const initTronWeb = async () => {
  if (window?.tronWeb && window?.tronWeb?.ready) {
    setTronWeb(window.tronWeb);
    
    // Get all available addresses
    const addresses = await getAllAddressesAndBalances();
    setAvailableAddresses(addresses);
    
    // Set the first available address as default
    if (addresses.length > 0) {
      setAccount(addresses[0].address);
    }
    
    setIsConnected(window?.tronWeb?.ready?true:false)   
    const fullNodeUrl = window.tronWeb.fullNode.host;
    if (fullNodeUrl.includes('trongrid.io')) {
      if (fullNodeUrl.includes('shasta')) {
        setNetwork('Shasta Testnet');
      } else {
        setNetwork('Mainnet');
      }
    } else {
      setNetwork('Private Network');
    }
  } else {
    console.log('TronLink is not installed or not ready');
  }
};

const requestTronLinkConnection = async () => {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  setIsLoading(true);
  if (window?.tronWeb) {
    try {
      // Check if window.tronLink and window.tronLink.request exist
      if (window.tronLink && typeof window.tronLink.request === "function") {
        const result = await window.tronLink.request({ method: 'tron_requestAccounts' });
        // Some versions may not return a code, just check if accounts are available
        if ((result && result.code === 200) || window.tronWeb.defaultAddress?.base58) {
          initTronWeb();
        } else {
          console.error('TronLink connection failed:', result?.message || result);
          setPaymentStatus({ type: "error", message: "TronLink connection failed. Please unlock your wallet and try again." });
        }
      } else {
        // Fallback: just try to initTronWeb (may work if already connected)
        initTronWeb();
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Error requesting TronLink connection:', error);
      setIsLoading(false);
      setPaymentStatus({ type: "error", message: `Error requesting TronLink connection: ${error}` });
    }
  } else if (isMobile) {
    // Not in TronLink browser
    if (navigator.userAgent.includes("TronLink")) {
      // In TronLink in-app browser, but tronWeb not ready
      setPaymentStatus({ type: "error", message: "TronLink is not ready. Please try again." });
    } else {
      // Not in TronLink browser
      setPaymentStatus({
        type: "error",
        message: (
          <div style={{ textAlign: "center" }}>
            <p>
              <b>To pay with TronLink on mobile:</b>
              <ol style={{ textAlign: "left", margin: "0 auto", display: "inline-block" }}>
                <li>Tap <b>Copy Link</b> below.</li>
                <li>Open the <b>TronLink</b> app.</li>
                <li>Go to the <b>Browser</b> tab in TronLink.</li>
                <li>Paste the link in the address bar and open it.</li>
                <li>Connect your wallet and complete the payment.</li>
              </ol>
            </p>
            <button
              style={{
                background: "var(--blue-violet)",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                padding: "8px 16px",
                marginTop: "8px",
                cursor: "pointer"
              }}
              onClick={() => {
                copy(window.location.href);
                showToast(
                  "Your link is copied to the clipboard.",
                  ToastType.SUCCESS
                );
                startAgainAction()
                window.scrollTo(0, 0);                
              }}
            >
              Copy Link
            </button>
          </div>
        )
      });
    }
    setIsLoading(false);
  } else {
    setIsLoading(false);
    setPaymentStatus({ type: "error", message: "Please install TronLink to connect your wallet." });
  }
};

const handleTransfer = async () => {
setIsLoading(true)
  if (!window?.tronWeb || !recipientAddress || !payamount) {    
    requestTronLinkConnection()
    return;
  }

  try {    
    // Find address with sufficient balance
    const addressWithBalance = await checkHDWalletStatus(payamount, coinInfo?.Type || "TRX");
    
          if (!addressWithBalance) {
        setPaymentStatus({ 
          type: "error", 
          message: `Insufficient ${coinInfo?.Type || "TRX"} balance in your HD wallet. Please check your wallet balance and ensure it's active.` 
        });
        setIsLoading(false);
        return;
      }

    console.log(`Using address: ${addressWithBalance.address} (${addressWithBalance.type}) with balance: ${addressWithBalance.balance}`);
    setSelectedAddress(addressWithBalance.address || null);

if(coinInfo?.Type == "USDT"){
  const amountInSun = payamount * 1e6;

  const contractValue = await tronWeb.contract().at(coinInfo?.ContractAddress);
  
  // Use the address with sufficient balance
  const PayWithUsdt = await contractValue.transfer(recipientAddress, amountInSun).send({
    from: addressWithBalance.address
  });
  
  // Get the transaction hash
  const txnHash = PayWithUsdt.transaction.txID;
  if(txnHash){
    payNow({...PayWithUsdt?.transaction,hash:txnHash, orderId: `VTE-TRX-${txnHash?.substring(0, 4)}` })
  }
  console.log(PayWithUsdt,"PayWithUsdtPayWithUsdt")
}else{
  
  const sunAmount = tronWeb.toSun(payamount);
  const transaction = await tronWeb.trx.sendTransaction(recipientAddress, sunAmount, {
    from: addressWithBalance.address
  });
  const transactionId = transaction.txid;    
  console.log(transaction,"transactionIdtransactionId")
  if(transactionId){
    payNow({...transaction,hash:transactionId, orderId: `VTE-TRX-${transactionId?.substring(0, 4)}` })
  }    
}
    // setPaymentStatus({ type: "success", message: "Transaction successful!"})        
  } catch (error) {
    setIsLoading(false)
    console.error('Transaction failed:', error);
    // @ts-ignore
    // alert('Transaction failed' + error);
    setPaymentStatus({ type: "error", message: "Transaction failed" })
  }
};

  return (
    <>
    <div>
      {/* @ts-ignore  */}
      {isConnected ?
              <div
        className={`${window.screen.width > 767 ? "" : "mt-3"} d-flex justify-content-center`}
      >
        <ButttonDiv className="mt-1">
          <button                        
            onClick={() => {
              if(process.env.REACT_APP_SITE_URL?.includes("staging")){
                if(network=="Shasta Testnet" && coinInfo.Type=="USDT"){
                  setPaymentStatus({ type: "error", message: "You can't pay with Testnet. Please switch to the Mainnet in your wallet." })
                  return
                }else{
                  handleTransfer()     
                }
              }
              if(!process.env.REACT_APP_SITE_URL?.includes("staging")){
                if(network=="Shasta Testnet"){
                  setPaymentStatus({ type: "error", message: "You can't pay with Testnet. Please switch to the Mainnet in your wallet." })
                  return
              }else{
                handleTransfer()           
              }
            }
            }}
          >

            PAY NOW!
          </button>
        </ButttonDiv>
      </div > 
      :
      <div
      className={`${window.screen.width > 767 ? "" : "mt-3"} d-flex justify-content-center`}
    >
      <ButttonDiv className="mt-1">
        <button           
          onClick={() => {
            // tonConnectUi.openModal()          
            requestTronLinkConnection()        
          }}
        >
           CONNECT WALLET
        </button>
      </ButttonDiv>
    </div >
      }
{/* @ts-ignore  */}
  {isConnected && <>
        {coinInfo.Type=="USDT"&& network=="Shasta Testnet" && <div className='text-center mt-2'      >
            <p>You can't pay with Testnet. Please switch to the Mainnet in your wallet.</p>
        </div>}
        {!process.env.REACT_APP_SITE_URL?.includes("staging") && network=="Shasta Testnet" && <div className='text-center mt-2'      >
            <p>You can't pay with Testnet. Please switch to the Mainnet in your wallet.</p>
        </div>}
        {selectedAddress && (
          <div className='text-center mt-2'>
            <p>Using wallet: {selectedAddress.substring(0, 8)}...{selectedAddress.substring(selectedAddress.length - 8)}</p>
          </div>
        )}        
  </>}
    </div>
    </>
  )
}

export default TRONWallet
